<template>
  <el-dialog
      title="用户注册"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      custom-class="centerRegister"
  >
    <el-form
        ref="registerForm"
        :model="form"
        :rules="rules"
        label-width="80px"
        class="register-form"
        autocomplete="off"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
            v-model="form.username"
            placeholder="请输入用户名"
            clearable
            autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input
            v-model="form.password"
            placeholder="请输入密码"
            type="password"
            show-password
            clearable
            autocomplete="new-password"
        ></el-input>
      </el-form-item>

      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
            v-model="form.confirmPassword"
            placeholder="请再次输入密码"
            type="password"
            show-password
            clearable
            autocomplete="new-password"
        ></el-input>
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
            clearable
            autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input
            v-model="form.email"
            placeholder="请输入邮箱"
            clearable
            autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="false" label="注册角色" prop="userType">
        <el-select style="width: 100%" v-model="form.userType" placeholder="请选择需要注册的角色">
          <el-option v-for="item in rolesList" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item label="验证码" prop="captcha" v-if="showCaptcha">
        <div class="captcha-container">
          <el-input
              v-model="form.captcha"
              placeholder="请输入验证码"
              style="width: 60%"
              clearable
          ></el-input>
          <img
              :src="captchaSrc"
              @click="refreshCaptcha"
              alt="验证码"
              class="captcha-img"
              title="点击刷新验证码"
          />
        </div>
      </el-form-item>

      <el-form-item prop="agreedToTerms">
        <el-checkbox v-model="form.agreedToTerms">
          我已阅读并同意
          <el-button type="text" @click.prevent="showAgreement">《用户注册协议》</el-button>
        </el-checkbox>
      </el-form-item>

      <el-form-item>
        <el-button
            type="primary"
            @click="submitForm"
            :loading="loading"
            style="width: 100%"
        >
          立即注册
        </el-button>
      </el-form-item>

      <div class="login-link">
        已有账号？
        <el-button type="text" @click="toLogin">立即登录</el-button>
      </div>
    </el-form>

    <el-dialog
        title=""
        :visible.sync="agreementVisible"
        width="70%"
        :append-to-body="true"
        custom-class="agreement-dialog"
    >
      <div class="agreement-content">
        <h2 style="text-align: center">用户注册协议</h2>
        <p style="text-align: center;margin-bottom: 20px"><strong>欢迎您使用天府再生资源平台！</strong></p>
        <h3>一、协议的接受与修改</h3>
        <p>1.1 本协议是您与天府再生资源平台之间关于使用本平台服务所订立的协议。</p>
        <p>1.2 请您在注册前仔细阅读本协议，特别是免除或者限制责任的条款、权利许可和信息使用的条款、同意开通或使用特殊单项服务的条款、法律适用和争议解决条款等。如您对本协议有任何疑问，可向平台客服咨询。</p>
        <p>1.3 当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与平台达成一致，成为平台的"用户"。</p>
        <p>1.4 平台有权根据需要不时地修订本协议及/或各类规则，并以在线公告的方式进行变更公告。若您在前述公告修订后继续使用本平台服务，即视为您已阅读、理解并接受经过修订的协议和规则。</p>

        <h3>二、账号注册与使用</h3>
        <p>2.1 您在注册时应当按照法律法规要求提供真实、准确、完整的个人或企业信息（包括但不限于姓名、联系方式、身份证明等），并及时更新上述信息。</p>
        <p>2.2 您应妥善保管您的账号和密码，因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。</p>
        <p>2.3 您有权根据自己的意愿随时更改注册资料，若因您提供的注册资料不合法、不真实、不准确或不及时而引发的法律责任由您自行承担。</p>
        <p>2.4 您的账号仅限您本人或本企业使用，禁止赠与、借用、租用、转让或售卖。如发现他人未经授权使用您的账号，应立即通知平台。</p>

        <h3>三、用户行为规范</h3>
        <p>3.1 您在使用本平台服务时，必须遵守中华人民共和国相关法律法规的规定，不得利用本平台从事任何违法活动。</p>
        <p>3.2 您不得利用本平台制作、复制、发布、传播含有下列内容的信息：</p>
        <ul>
          <li>反对宪法所确定的基本原则的；</li>
          <li>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
          <li>损害国家荣誉和利益的；</li>
          <li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
          <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
          <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
          <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
          <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
          <li>含有法律、行政法规禁止的其他内容的。</li>
        </ul>
        <p>3.3 您不得从事任何可能干扰或破坏本平台正常运行的行为，包括但不限于：</p>
        <ul>
          <li>未经授权访问本平台系统或数据；</li>
          <li>试图探测、扫描或测试本平台系统的漏洞；</li>
          <li>干扰或破坏本平台服务器或网络；</li>
          <li>使用自动化程序或机器人访问本平台；</li>
          <li>其他违反法律法规或损害平台利益的行为。</li>
        </ul>

        <h3>四、隐私保护</h3>
        <p>4.1 平台重视对您个人隐私的保护，平台将按照《隐私政策》收集、存储、使用、披露和保护您的个人信息。</p>
        <p>4.2 《隐私政策》是本协议不可分割的一部分，您注册并使用本平台服务即表示您同意按照《隐私政策》处理您的个人信息。</p>
        <p>4.3 您可以访问、更正、删除您的个人信息，也可以通过注销账号的方式撤回授权。</p>

        <h3>五、知识产权声明</h3>
        <p>5.1 本平台包含的所有内容，包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、电子文档等，均受著作权法和其他知识产权法律法规的保护。</p>
        <p>5.2 未经平台书面许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）本平台上的内容。</p>
        <p>5.3 您在使用本平台服务过程中产生的内容，其知识产权归您所有，但您授予平台在全球范围内免费的、永久的、不可撤销的、非独家的使用权。</p>

        <h3>六、免责声明</h3>
        <p>6.1 您理解并同意，本平台服务是按照现有技术和条件所能达到的现状提供的，平台会尽最大努力向您提供服务，确保服务的连贯性和安全性。</p>
        <p>6.2 鉴于网络服务的特殊性，平台有权随时变更、中断或终止部分或全部的网络服务，无需事先通知用户，也无需对用户或任何第三方承担任何责任。</p>
        <p>6.3 因不可抗力（包括但不限于自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等）、计算机病毒、黑客攻击、系统不稳定、通信线路故障等技术原因导致的服务中断或数据丢失，平台不承担责任。</p>
        <p>6.4 您通过本平台与其他用户或第三方进行交易或产生其他交互行为，由此产生的纠纷由您自行解决，平台不承担任何责任。</p>

        <h3>七、违约处理</h3>
        <p>7.1 如果您违反本协议的任何条款，平台有权根据实际情况采取以下一种或多种措施：</p>
        <ul>
          <li>要求您纠正违规行为；</li>
          <li>暂停或终止向您提供服务；</li>
          <li>删除您发布的违规内容；</li>
          <li>冻结或注销您的账号；</li>
          <li>追究您的法律责任并要求赔偿损失。</li>
        </ul>
        <p>7.2 因您的违约行为给平台或其他用户造成损失的，您应当承担赔偿责任，包括但不限于直接经济损失、商誉损失以及平台为此支付的诉讼费、律师费、公证费等合理费用。</p>

        <h3>八、协议的终止</h3>
        <p>8.1 您有权通过注销账号的方式终止本协议。</p>
        <p>8.2 出现以下情况时，平台有权终止本协议：</p>
        <ul>
          <li>您违反本协议约定，平台依据违约条款终止服务；</li>
          <li>您注册的账号长期未使用，平台有权回收账号资源；</li>
          <li>平台经营策略调整，提前30天公告后终止服务；</li>
          <li>法律法规规定的其他情形。</li>
        </ul>
        <p>8.3 协议终止后，平台有权依法删除您的相关信息，但法律法规另有规定的除外。</p>

        <h3>九、法律适用与争议解决</h3>
        <p>9.1 本协议的订立、执行、解释及争议的解决均应适用中华人民共和国法律。</p>
        <p>9.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向平台所在地有管辖权的人民法院提起诉讼。</p>

        <h3>十、其他条款</h3>
        <p>10.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
        <p>10.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
        <p>10.3 本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。</p>
        <p>10.4 如您对本协议有任何意见建议，可通过客服渠道联系我们。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreementVisible = false">我已知晓</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { registerRoles, getVerificationCode } from '@/API/login/login'
export default {
  name: 'RegisterDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showCaptcha: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        callback(new Error('请输入正确的邮箱地址'))
      } else {
        callback()
      }
    }
    const validateAgreement = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请阅读并同意用户注册协议'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: this.visible,
      loading: false,
      captchaDisabled: false,
      captchaText: '获取验证码',
      countdown: 60,
      agreementVisible: false,
      deviceId: '',
      captchaSrc: '',
      form: {
        username: '',
        password: '',
        confirmPassword: '',
        phone: '',
        email: '',
        userType: 1,
        captcha: '',
        agreedToTerms: false
      },
      // rolesList:[
      //   {
      //     value:1,
      //     label:"普通用户"
      //   },
      //   {
      //     value:3,
      //     label:"政府用户"
      //   },
      //   {
      //     value:4,
      //     label:"监管用户"
      //   },
      // ],
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              let passwordReg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
              console.log(passwordReg.test(value))
              if (!passwordReg.test(value)) {
                callback(new Error('密码须至少包含大小写字母、数字、特殊符号中的2种'))
              }
              else{
                callback()
              }
            }
          }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        userType: [
          { required: true, message: '请选择需要注册的角色', trigger: 'change' },
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '验证码长度为4位', trigger: 'blur' }
        ],
        agreedToTerms: [
          { validator: validateAgreement, trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.showCaptcha) {
        this.$nextTick(() => {
          this.refreshCaptcha()
        })
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    // 显示协议
    showAgreement() {
      this.agreementVisible = true
    },

    // 刷新验证码
    refreshCaptcha() {
      this.deviceId = JSON.stringify(new Date().getTime())
      getVerificationCode(this.deviceId)
          .then((res) => {
            const base64 = btoa(
                new Uint8Array(res).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    '',
                ),
            )
            this.captchaSrc = `data:image/png;base64,${base64}`
          })
          .catch((error) => {
            console.error('获取验证码失败:', error)
            this.$message.error('验证码加载失败，请重试')
          })
    },

    // 提交表单
    submitForm() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          if (!this.form.agreedToTerms) {
            this.$message.warning('请先阅读并同意用户注册协议')
            return
          }
          this.loading = true
          // 这里替换为实际的注册API调用
          registerRoles(this.form)
              .then(response => {
                if(response.code === 200){
                  this.$message.success('注册成功，请前往登录！')
                  this.$emit('register-success', response.data)
                }else {
                  this.$message.error(response.message ? response.message : '注册失败')
                }
                this.dialogVisible = false
              })
              .catch(error => {
                this.$message.error(error.response?.data?.message || '注册失败')
              })
              .finally(() => {
                this.loading = false
              })
        } else {
          return false
        }
      })
    },

    // 获取验证码
    getCaptcha() {
      if (!this.form.phone) {
        this.$message.warning('请先输入手机号')
        return
      }

      this.$refs.registerForm.validateField('phone', valid => {
        if (!valid) {
          // 这里替换为实际的获取验证码API调用
          this.$axios.post('/api/captcha', { phone: this.form.phone })
              .then(() => {
                this.$message.success('验证码已发送')
                this.startCountdown()
              })
              .catch(error => {
                this.$message.error(error.response?.data?.message || '验证码发送失败')
              })
        }
      })
    },

    // 开始倒计时
    startCountdown() {
      this.captchaDisabled = true
      const timer = setInterval(() => {
        this.countdown--
        this.captchaText = `${this.countdown}秒后重新获取`
        if (this.countdown <= 0) {
          clearInterval(timer)
          this.captchaDisabled = false
          this.captchaText = '获取验证码'
          this.countdown = 60
        }
      }, 1000)
    },

    // 重置表单
    resetForm() {
      this.$refs.registerForm.resetFields()
      this.loading = false
      this.agreementVisible = false
      this.refreshCaptcha()
    },

    // 关闭弹窗
    handleClose(done) {
      this.$confirm('确定关闭注册窗口吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => {})
    },

    // 跳转到登录
    toLogin() {
      this.dialogVisible = false
      this.$emit('to-login')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.centerRegister {
  width:500px;
}
.register-form {
  padding: 0 20px;
}

.captcha-container {
  display: flex;
  align-items: center;

  .captcha-img {
    width: 35%;
    height: 40px;
    margin-left: 5%;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;

    &:hover {
      border-color: #409EFF;
      opacity: 0.8;
    }
  }
}

.login-link {
  text-align: center;
  color: #606266;
  margin-top: -15px;
  margin-bottom: 10px;
}

.el-button--text {
  padding: 0;
  margin-left: 5px;
}
@media screen and (max-width: 768px) {
  /deep/.centerRegister {
    width:90% !important;
  }
}
.dialog-footer {
  display: block;
  text-align: center;
}
</style>
